import BaseException from './BaseException';

class ServerMaintenanceRedirectException extends BaseException {
  readonly name = 'ServerMaintenanceRedirectException';

  constructor() {
    super({
      errors: [
        {
          description: 'redirect',
          status: 307,
        },
      ],
    });
  }
}

export default ServerMaintenanceRedirectException;
